import mirror from 'keymirror';
import has from 'lodash/has';
import Library from '../lib/library';
import { getSongByID } from './song';

export const actionTypes = mirror({
  CURRENT_PRACTICE_SET: null,
  PRACTICE_GET_ERROR: null,
  PRACTICE_GET_IN_PROGRESS: null,
  PRACTICE_GET_SUCCESS: null,
  CLEAR_WATCHING: null,
});

export const clearWatching = () => ({
  type: actionTypes.CLEAR_WATCHING,
});

const practiceGetInProgress = () => ({
  type: actionTypes.PRACTICE_GET_IN_PROGRESS,
});

const practiceGetError = error => ({
  type: actionTypes.PRACTICE_GET_ERROR,
  error,
});

const practiceGetSuccess = results => ({
  type: actionTypes.PRACTICE_GET_SUCCESS,
  results,
});

const setCurrentPractice = practiceSlug => ({
  type: actionTypes.CURRENT_PRACTICE_SET,
  practiceSlug,
});

export function getPractice(options, unseenPath = false) {
  return async (dispatch, getState) => {
    try {
      dispatch(practiceGetInProgress());
      const state = getState();
      const isPrivate =
        state.fenderConnect.subscriptions &&
        (state.fenderConnect.subscriptions.play === 'active' ||
          state.fenderConnect.subscriptions.play === 'pending');
      const results = await Library.getLessons(options, !isPrivate, unseenPath);
      const hasItems = has(results, 'items');
      if (hasItems && results.items.length) {
        const hasSongID = has(results.items[0], 'song');
        const songID = hasSongID ? results.items[0].song : null;
        await getSongByID(songID)(dispatch, getState);
        dispatch(practiceGetSuccess(results));
        dispatch(setCurrentPractice(options.slug));
      } else {
        dispatch(practiceGetError('Practice not found'));
      }
    } catch (err) {
      dispatch(practiceGetError(err));
    }
  };
}
